import React from 'react';
import './index.scss';

const Footer = () => (
  <footer className="footer-block">
    <div className="block-inner">
      <a href="/" className="sheep">Lana</a>
    </div>
  </footer>
);

export default Footer;
